import Link from "next/link"
import { Card, CardBody, CardImage, Stack, Typography } from "@octopus-energy/coral/atoms"
import { shortenTextByWords } from "@oefr/utils/string"
import { type SbBlogPostStory } from "@/features/storyblok/types"
import { getStoryHref } from "@/features/storyblok/utils/getStoryHref"

type BlogPostPreviewProps = { story: SbBlogPostStory }

const DEFAULT_IMAGE_HEIGHT = 240

export function BlogPostPreview({ story }: BlogPostPreviewProps) {
    return (
        <Link
            href={getStoryHref(story)}
            style={{ textDecoration: "none", display: "inline-grid" }}
        >
            <Card
                borderless
                theme="base100"
                padding="none"
            >
                {story.content.image?.filename && (
                    <CardImage
                        height={story.content.imageHeightOverride || DEFAULT_IMAGE_HEIGHT}
                        src={story.content.image?.filename}
                    />
                )}
                <CardBody padding="medium">
                    <Stack
                        flexDirection="column"
                        gap="lg"
                    >
                        <Typography
                            attributes={{ "data-testid": `post-title-${story.uuid}` }}
                            textStyle="h4"
                            component="p"
                            color="inherit"
                        >
                            {story.content.title}
                        </Typography>

                        <Typography
                            attributes={{ "data-testid": `post-intro-${story.uuid}` }}
                            color="inherit"
                        >
                            {shortenTextByWords(story.content.intro)}
                        </Typography>
                    </Stack>
                </CardBody>
            </Card>
        </Link>
    )
}
